import React, { useState } from 'react';
import api from '../services/api';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const res = await api.post('/auth/login', { email, password });
      localStorage.setItem('token', res.data.access_token);
      localStorage.setItem('usuario', JSON.stringify(res.data.usuario));
      window.location.href = '/';
    } catch {
      setError('Email o contraseña incorrectos');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', background:'#0f172a', display:'flex', alignItems:'center', justifyContent:'center' }}>
      <div style={{ background:'#1e293b', borderRadius:16, padding:36, width:380, border:'1px solid #334155' }}>
        <div style={{ textAlign:'center', marginBottom:28 }}>
          <div style={{ fontSize:48, marginBottom:8 }}>💧</div>
          <h1 style={{ color:'#38bdf8', margin:0, fontSize:26, fontWeight:800 }}>Sistema de Agua</h1>
          <p style={{ color:'#64748b', margin:'6px 0 0', fontSize:13 }}>Panel de Administración</p>
        </div>
        <form onSubmit={handleLogin}>
          <div style={{ marginBottom:16 }}>
            <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:6 }}>EMAIL</label>
            <input value={email} onChange={e => setEmail(e.target.value)}
              type="email" placeholder="admin@agua.com" required
              style={{ width:'100%', background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'10px 14px', color:'white', fontSize:14, boxSizing:'border-box' }} />
          </div>
          <div style={{ marginBottom:20 }}>
            <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:6 }}>CONTRASEÑA</label>
            <input value={password} onChange={e => setPassword(e.target.value)}
              type="password" placeholder="••••••••" required
              style={{ width:'100%', background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'10px 14px', color:'white', fontSize:14, boxSizing:'border-box' }} />
          </div>
          {error && <div style={{ background:'#ef444411', border:'1px solid #ef444433', borderRadius:8, padding:'10px 14px', color:'#ef4444', fontSize:13, marginBottom:16 }}>{error}</div>}
          <button type="submit" disabled={loading}
            style={{ width:'100%', background:'#0ea5e9', border:'none', borderRadius:10, padding:'12px', color:'white', fontSize:15, fontWeight:700, cursor:'pointer' }}>
            {loading ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
